const WARNING_MESSAGES = {
    SESSION_INVALID: 'Sesión expirada. Por favor cerrar sesión',
    USER_WITHOUT_BANNER_ID: 'No se encontró el Banner ID, comunícate con Dragon Help sd@usfq.edu.ec.',
    RESOURCE_NOT_FOUND: 'Recurso no encontrado',
    USER_REQUIRED: 'Se debe elegir un usuario',
    AUTHORIZATION_FAILD: 'No tiene autorización para realizar esta acción',
}

export default WARNING_MESSAGES;